import React from "react";
import { Tabs } from "antd";
import TestWiseReport from "../TestWiseReport";
import BillingReport from "../BillingReport";
import PhleboIncentiveReport from "../PhleboIncentiveReport";
import CouponCodeReport from "./CouponCodeReport";
import TatReport from "./TatReport";
import WETATFailure from "../WETATFailure";
import TatFailureReport from "./TatFailureReport";
import DiseaseReport from "./DiseaseReport";

const ReportTab = () => {
  const items = [
    {
      key: "1",
      label: "Test Wise Report",
      children: <TestWiseReport />,
    },
    {
      key: "2",
      label: "Billing Report",
      children: <BillingReport />,
    },
    {
      key: "3",
      label: "Phlebo Incentive Report",
      children: <PhleboIncentiveReport />,
    },
    {
      key: "4",
      label: "Coupon Code Report",
      children: <CouponCodeReport />,
    },
    {
      key: "5",
      label: "Tat Report",
      children: <TatReport />,
    },
    {
      key: "6",
      label: "WE TAT Failure",
      children: <WETATFailure />,
    },
    {
      key: "7",
      label: "Report TAT Failure",
      children: <TatFailureReport />,
    },
    {
      key: "8",
      label: "Disease Report",
      children: <DiseaseReport />,
    },
  ];

  return (
    <>
      <Tabs
        defaultActiveKey="1"
        items={items}
        tabBarStyle={{ overflowX: "auto", flexWrap: "nowrap" }}
      />
      <style>{`
        @media (max-width: 768px) {
          .ant-tabs-nav-wrap {
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
          }
          .ant-tabs-nav-list {
            flex-wrap: nowrap !important;
          }
          .ant-tabs-tab {
            white-space: nowrap;
            font-size: 12px !important;
            padding: 6px 10px !important;
          }
        }
      `}</style>
    </>
  );
};

export default ReportTab;